// Port of api/fuel/app/classes/filter/search/games/filters/query/play/reports/required.php
export default {
	name: 'play.reports.required',
	priority: 65,
	require: function(config, filter) { return filter.play && filter.play.reports && filter.play.reports.required },
	run: function(config, filter, data, query) {
		if (filter.play.reports.required === 1) query.where('p.play_comment', '<>', '')
		else if (filter.play.reports.required === 2) query.where('p.play_comment', '=', '')
	}
}
